// extracted by mini-css-extract-plugin
module.exports = {"suggested-actions":"SuggestedActions_suggested-actions__rXyja","suggested-actions__action":"SuggestedActions_suggested-actions__action__1RYpM"};